<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M20.19 9.44a1.5 1.5 0 012.12 0l21.5 21.5a1.5 1.5 0 010 2.12l-21.5 21.5a1.5 1.5 0 01-2.12-2.12L40.628 32l-20.44-20.44a1.5 1.5 0 010-2.12z"/></svg>